<template>
  <svg :height="size" :width="size" fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      :stroke="color"
      d="M16.0001 18.9919C19.0355 18.9919 21.4961 16.5313 21.4961 13.496C21.4961 10.4606 19.0355 8 16.0001 8C12.9648 8 10.5042 10.4606 10.5042 13.496C10.5042 16.5313 12.9648 18.9919 16.0001 18.9919Z"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="2"
    />
    <path
      :fill="color"
      d="M24 29.6C24 25.6 20.1177 23.8801 16.0006 23.8801C11.8831 23.8801 8 25.6 8 29.6C8 29.6 9.02816 32 16.0006 32C22.9731 32 24 29.6 24 29.6Z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneAvatarCircle",
  props: {
    size: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: "#545454",
    },
  },
});
</script>

<style scoped></style>
